import React from "react";

function TabContent(props) {
  const {
    item,
    idx,
    activeTabId,
    additionalClasses = "",
    additionalContentClasses = "",
    isVertical = true
  } = props;

  const layout = isVertical ? "vertical" : "horizontal";
  const orientationOpts = {
    vertical: "h-96 sm:h-[750px]",
    horizontal: "h-60"
  };
  return (
    <div
      key={`tab-content-item-${idx}`}
      className={`${activeTabId === idx ? "block" : "hidden"} ${orientationOpts[layout]} ${additionalClasses}  tab-content pl-1 sm:pl-3 pr-4 overflow-y-scroll  gvi-scrollbar-thin tab-content_html masked-overview masked-overview-down`}
    >
      {item?.comp || (
        <div
          className={additionalContentClasses}
          dangerouslySetInnerHTML={{ __html: item?.text }}
        />
      )}
    </div>
  );
}

export default TabContent;
